module.exports = __webpack_public_path__ + "img/hooch_tennis.fbbc3780.jpg";